import * as server from '../entries/pages/(app)/portal/_layout.server.ts.js';

export const index = 4;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/layout.svelte.js')).default;
export { server };
export const server_id = "src/routes/(app)/portal/+layout.server.ts";
export const imports = ["_app/immutable/nodes/4.C3Pq2-3Z.js","_app/immutable/chunks/disclose-version.BrU4QSF1.js","_app/immutable/chunks/runtime.B_Tq2JvT.js","_app/immutable/chunks/snippet.D4sFeWrl.js"];
export const stylesheets = [];
export const fonts = [];
